type Props = {
  height: string;
  stroke: string;
  width: string;
};
const MailIcon = ({ height, stroke, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.5"
        y="6"
        width="18"
        height="13"
        rx="1"
        stroke={stroke}
        strokeWidth="2"
      />
      <path
        d="M3.5 6L11.8861 12.5225C12.2472 12.8034 12.7528 12.8034 13.1139 12.5225L21.5 6"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};

export default MailIcon;
